<script>
import {supabase} from "./supabaseClient"
import { MaterialApp, Avatar,List,ListItem,Divider, Subheader, Menu} from 'svelte-materialify';
import { createEventDispatcher } from 'svelte';

export let user;

const dispatch = createEventDispatcher();

let userInitials = $user ? $user.email.substring(0,1).toUpperCase() : ''
let userEmail = $user ? $user.email : ''

const navMyBoards = async () => {
  window.location.href='/myboards'
}

</script>


  <Menu nudgeX="-160" XoffsetX="true">
  <div slot="activator">
    <Avatar size="36px" class="Xprimary-color" style="background-color:var(--blue); color: white; cursor:pointer">{userInitials}</Avatar>
  </div>
  <List>
    <ListItem>
      <div style="font-size:8p; line-height: 20px; color:var(--blue); font-weight: bold">{userEmail}</div>
      {#if user && user.plan}
        <div style="font-size:8p; line-height: 20px; color:var(--aqua)">{user.plan.plan_name} Plan</div>
      {/if}
    </ListItem>
    <Divider style="border-color:#dbdbdb !important"/>
    <ListItem on:click={navMyBoards} style="background-color:white">My Boards</ListItem>
    <ListItem on:click={(e) => {dispatch('SignOut')}} style="background-color:white">Sign Out</ListItem>
  </List>
</Menu>
